import React from 'react';
import { Modal, Form } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import FormErrorCode from './FormErrorCode';
import { fetchEditErrorCode } from '../../../../store/ErrorCodeSlice';
import { AppDispatch } from '../../../../store/app';
import { useDispatch } from 'react-redux';

const EditErrorCode: React.FC<any> = (props) => {
  const { handleEditModal, openEditModal, dataEditModal, getList } = props;

  const [form] = Form.useForm();
  const dispatch: AppDispatch = useDispatch();

  const handleSubmit = (data: any) => {
    dispatch(fetchEditErrorCode(data))
      .then(() => {
        handleEditModal();
        getList();
      })
      .catch(() => {
        handleEditModal();
      });
  };
  return (
    <>
      <Modal
        open={openEditModal}
        destroyOnClose  
        width={800}
        onCancel={handleEditModal}
        closeIcon={<FontAwesomeIcon icon={faTimes} />}
        footer={false}
        className="addModal"
        title={`Edit Error Code`}
      >
        <FormErrorCode
          dataEditModal={dataEditModal}
          form={form}
          handleEditErrorCode={handleSubmit}
          isEdit={true}
        />
      </Modal>
    </>
  );
};

export default EditErrorCode;
